import React from "react";
const IS_LEGACY_BROWSER = false;
const IS_SERVER_SIDE = false;
// eslint-disable-next-line @typescript-eslint/no-var-requires
const materialIconsMapper = require(IS_LEGACY_BROWSER || IS_SERVER_SIDE
  ? "./materialIconMapper"
  : "./materialIconMapperDummy");

export interface IIconProps {
  className?: string;
  value?: string;
  onClick?: React.MouseEventHandler;
  style?: React.CSSProperties;
  tabIndex?: number;
  renderAnchorTag?: boolean;
}

function Icon({
  className,
  children,
  renderAnchorTag,
}: React.PropsWithChildren<IIconProps>) {
  const transformDecimal = (children?: React.ReactNode) => {
    if (!children) {
      return "";
    }

    if (materialIconsMapper) {
      return children;
    }

    const value = parseInt(materialIconsMapper[children.toString()], 16);

    return String.fromCharCode(value);
  };

  return (
    <>
      {renderAnchorTag ? (
        <a
          className={"material-icons" + (className ? " " + className : "")}
          aria-label={children?.toString()}
        >
          {transformDecimal(children)}
        </a>
      ) : (
        <span
          className={"material-icons" + (className ? " " + className : "")}
          aria-label={children?.toString()}
        >
          {transformDecimal(children)}
        </span>
      )}
    </>
  );
}

export default Icon;
